import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledItems } from "./items.styled";
import { SEARCH_TABLE_STYLE } from "./items.constants";
import { useItemOptions } from "./items.data";
import { useItemStructures } from "./useItemStructures";
import { useItemsBrowse } from "./useItemsBrowse";
import { useItemsNavigation } from "./useItemsNavigation";

function Items() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useItemStructures();
  const browse = useItemsBrowse();
  const navigation = useItemsNavigation();
  const itemOptions = useItemOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledItems>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.itemSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton variant="rectangular" height={100} animation="wave" sx={skeletonSx} />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={itemOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledItems>
  );
}

export default Items;
